module.exports = __webpack_public_path__ + "media/application/images/demsoc/hero/polychrome_2-08276c39d28ed6752e48c004a2289612.jpg";